// extracted by mini-css-extract-plugin
module.exports = {"block":"J5d7","mainNews":"J5akv","secondNews":"J5akx","wrap":"J5av","imageWrap":"J5o-","image":"J5ob","title":"J5al","date":"J5g7","advLabel":"J5kh"};